import React from 'react';
import Btn from '../Btn';
import IUrl from '../../../types/IUrl';
import extendClassNameWithModifier from '../../../lib/bemUtils/bem';
import { Modifier } from '../../../lib/bemUtils/Modifier';

export enum FooterLinkModifier {
  BORDER_BOTTOM = 'footer-link--border-bottom',
  NO_BORDER_TOP = 'footer-link--no-border-top',
}

type FooterLinkProps = {
  footerButtonLabel: string;
  footerLink?: IUrl;
  modifier?: Modifier<FooterLinkModifier>;
};

export function FooterLink({ footerButtonLabel, footerLink, modifier }: FooterLinkProps) {
  if (footerLink?.url) {
    return (
      <div className={extendClassNameWithModifier('footer-link', modifier)}>
        <Btn text={footerButtonLabel} href={footerLink.url} />
      </div>
    );
  }
  return null;
}
